module.exports = __webpack_public_path__ + "static/HarrisTeeter_pin-4d396f2b00be47196b8213adb38a20c8.png";